"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorResult = exports.isOkResult = exports.createErrorResult = exports.createOkResult = void 0;
const createOkResult = (data) => {
    return {
        result: 'ok',
        data,
    };
};
exports.createOkResult = createOkResult;
const createErrorResult = (error) => {
    const errorObj = error;
    if (errorObj?.message) {
        return {
            result: 'error',
            error: errorObj.message,
        };
    }
    return {
        result: 'error',
        error: error,
    };
};
exports.createErrorResult = createErrorResult;
const isOkResult = (result) => {
    return result.result === 'ok';
};
exports.isOkResult = isOkResult;
const isErrorResult = (result) => {
    return result.result === 'error';
};
exports.isErrorResult = isErrorResult;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0Lm1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZGVscy9yZXN1bHQubW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBWU8sTUFBTSxjQUFjLEdBQUcsQ0FBVyxJQUFjLEVBQXNCLEVBQUU7SUFDN0UsT0FBTztRQUNMLE1BQU0sRUFBRSxJQUFJO1FBQ1osSUFBSTtLQUNMLENBQUE7QUFDSCxDQUFDLENBQUE7QUFMWSxRQUFBLGNBQWMsa0JBSzFCO0FBRU0sTUFBTSxpQkFBaUIsR0FBRyxDQUFDLEtBQXFCLEVBQWUsRUFBRTtJQUN0RSxNQUFNLFFBQVEsR0FBRyxLQUFjLENBQUE7SUFFL0IsSUFBSSxRQUFRLEVBQUUsT0FBTyxFQUFFO1FBQ3JCLE9BQU87WUFDTCxNQUFNLEVBQUUsT0FBTztZQUNmLEtBQUssRUFBRSxRQUFRLENBQUMsT0FBTztTQUN4QixDQUFBO0tBQ0Y7SUFFRCxPQUFPO1FBQ0wsTUFBTSxFQUFFLE9BQU87UUFDZixLQUFLLEVBQUUsS0FBZTtLQUN2QixDQUFBO0FBQ0gsQ0FBQyxDQUFBO0FBZFksUUFBQSxpQkFBaUIscUJBYzdCO0FBRU0sTUFBTSxVQUFVLEdBQUcsQ0FBVyxNQUE0QixFQUFnQyxFQUFFO0lBQ2pHLE9BQU8sTUFBTSxDQUFDLE1BQU0sS0FBSyxJQUFJLENBQUE7QUFDL0IsQ0FBQyxDQUFBO0FBRlksUUFBQSxVQUFVLGNBRXRCO0FBRU0sTUFBTSxhQUFhLEdBQUcsQ0FBVyxNQUE0QixFQUF5QixFQUFFO0lBQzdGLE9BQU8sTUFBTSxDQUFDLE1BQU0sS0FBSyxPQUFPLENBQUE7QUFDbEMsQ0FBQyxDQUFBO0FBRlksUUFBQSxhQUFhLGlCQUV6QiJ9